export const iconFontAwesomeCommunicationBluetoothB = (
	<i className="fa-solid fa-bluetooth-b"></i>
);
